/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
import { forEach, last, includes } from 'lodash';
import {
    TOKEN_TYPE_FIELD,
    TOKEN_TYPE_FIELD_R,
    TOKEN_TYPE_OPERATOR,
    EXPRESSION_TYPE_FIELD,
    EXPRESSION_TYPE_FIELD_R,
    EXPRESSION_TYPE_OPERATOR,
    EXPRESSION_TYPE_RANGE,
    EXPRESSION_TYPE_ROOT,
    EXPRESSION_TYPE_TOKEN,
    TOKEN_TYPE_SPACE,
    TOKEN_TYPE_LOGIC,
} from '../../constants';
import Validation from './Validation';

const EXPRESSION_TYPE_FIELD_MAPS = [EXPRESSION_TYPE_FIELD, EXPRESSION_TYPE_FIELD_R];

export default class Expression {
    constructor(isRDVersion = false) {
        this.RootExpId = '0000000';
        this.LastId = '000000';
        this.TokenList = [];
        this.ExpressionList = [];
        this.ExpressionTree = {};
        this.isRDVersion = isRDVersion;
    }

    getExpression(TokenList) {
        this.ExpressionList = [];
        this.ExpressionTree = {};
        this.TokenList = TokenList;
        if (this.TokenList.length === 0) return;
        this.createExpression(EXPRESSION_TYPE_ROOT);
        this.initExpressionTree();
        if (localStorage.getItem('debugger')) {
            console.log('===ExpressionTree===');
            console.log(this.ExpressionTree);
        }
        // eslint-disable-next-line consistent-return
        return this.ExpressionTree;
    }

    initExpressionTree() {
        forEach(this.TokenList, (item, index) => {
            // 开启新的表达式
            if (item.type === TOKEN_TYPE_FIELD) {
                this.createExpression(EXPRESSION_TYPE_FIELD);
            } else if (item.type === TOKEN_TYPE_FIELD_R) {
                this.createExpression(EXPRESSION_TYPE_FIELD_R);
            } else if (item.type === TOKEN_TYPE_OPERATOR) {
                if (item.value === '(') {
                    this.createExpression(EXPRESSION_TYPE_OPERATOR);
                } else if (item.value === '[') {
                    this.createExpression(EXPRESSION_TYPE_RANGE);
                }
            }
            this.putItemIntoExpression({ item });
            // 结束表达式
            if (item.type === TOKEN_TYPE_OPERATOR) {
                if (item.value === ')') {
                    this.endExpression();
                } else if (item.value === ']') {
                    this.endExpression();
                }
            } else {
                const currentExpression = last(this.ExpressionList);
                const nextToken = this.TokenList[index + 1];
                if (includes(EXPRESSION_TYPE_FIELD_MAPS, currentExpression.expressionType)
            && currentExpression.children.length >= 3
            && (nextToken && (nextToken.type === TOKEN_TYPE_SPACE || nextToken.type === TOKEN_TYPE_LOGIC || nextToken.type === TOKEN_TYPE_OPERATOR))) {
                    this.endExpression();
                }
            }
        });
        if (this.ExpressionList.length > 0) {
            this.endAllExpression();
        }
    }

    createExpression(expressionType) {
        // eslint-disable-next-line no-plusplus
        const newId = (`000000${++this.LastId}`).slice(-7);
        let id = this.RootExpId;
        if (this.ExpressionList.length > 0) {
            id = `${id}_${newId}`;
        }
        const obj = {
            id,
            expressionType,
            children: [],
            offset: {},
            value: '',
        };
        this.ExpressionList.push(obj);
    }

    putItemIntoExpression({ item }) {
        const currentExpression = last(this.ExpressionList);
        currentExpression.children.push({
            expressionType: EXPRESSION_TYPE_TOKEN,
            data: item,
        });
    }

    endExpression() {
        if (this.ExpressionList.length === 1) return;
        let currentExpression = last(this.ExpressionList);
        const {
            offset,
            value,
        } = _getExpressionOffset(currentExpression);
        currentExpression.value = value;
        currentExpression.offset = offset;
        this.ExpressionList.pop();
        currentExpression = Validation.getExpressionError(currentExpression, this.ExpressionList, this.TokenList, this.isRDVersion);
        last(this.ExpressionList).children.push(currentExpression);

        currentExpression = last(this.ExpressionList);
        if (includes(EXPRESSION_TYPE_FIELD_MAPS, currentExpression.expressionType)
        && currentExpression.children.length >= 3) {
            this.endExpression();
        }
    }

    endAllExpression() {
        if (this.ExpressionList.length > 1) {
            this.endExpression();
            this.endAllExpression();
        } else if (this.ExpressionList.length === 1) {
            // eslint-disable-next-line prefer-destructuring
            this.ExpressionTree = this.ExpressionList[0];
            const {
                offset,
                value,
            } = _getExpressionOffset(this.ExpressionTree);
            this.ExpressionTree.offset = offset;
            this.ExpressionTree.value = value;
            this.ExpressionTree = Validation.getExpressionError(this.ExpressionTree, null, this.TokenList, this.isRDVersion);
        }
    }
}

// eslint-disable-next-line no-underscore-dangle
function _getExpressionOffset(currentExpression) {
    let value = '';
    let start = '';
    let end = '';
    if (currentExpression.children[0].expressionType === EXPRESSION_TYPE_TOKEN) {
        start = currentExpression.children[0].data.start;
    } else {
        start = currentExpression.children[0].offset.start;
    }
    if (last(currentExpression.children).expressionType === EXPRESSION_TYPE_TOKEN) {
        end = last(currentExpression.children).data.end;
    } else {
        end = last(currentExpression.children).offset.end;
    }
    forEach(currentExpression.children, (item) => {
        if (item.expressionType === EXPRESSION_TYPE_TOKEN) {
            value += item.data.value;
        } else {
            value += item.value;
        }
    });
    return {
        offset: { start, end },
        value,
    };
}
